import StringUtils from '../../utils/string-utils';
export default class Populator {
    constructor(input) {
        this.input = input;
        this.readOnly = input.el.dataset.readOnly !== undefined;
    }

    populate(value) {
        if(this.readOnly) {
            this.input.parent.el.classList.add('readonly');
            this.input.el.readOnly = true;
        }       

        if(this.input.type === 'checkbox' || this.input.type === 'radio' ) {
            this.input.el.checked = this.input.el.value === value;
        } else if(this.input.el.tagName === 'SELECT') {
            this.input.el.value = value;
            if(!this.input.el.value) {
                 this.input.el.value = [...(this.input.el.options ?? '[]')].find((option) => StringUtils.equalsIgnoreCase(option.textContent, value))?.value;                
            }
        } else {
            this.input.el.value = value;
        }
                
        this.input.el.dispatchEvent(new Event('change'));
    }

    equalsIgnoreCase(str1, str2) {
        return (str1 ?? '').trim().toLowerCase() === (str2 ?? '').trim().toLowerCase();
    }

    static applies(input) {
        return false;
    }
}
